import { BaseService } from "./common/base";

export class ServiceRequestService extends BaseService {
  constructor() {
    super("service-requests");
  }

  accept = (id, dispatchId) => this._post(`/${id}/accept/${dispatchId}`);
  decline = (id, dispatchId) => this._post(`/${id}/decline/${dispatchId}`);
  findPendingDispatch = () => this._get(`/pending-dispatch`);
  findSelfRequested = () => this._get(`/self-requested`);
  findRequestByPerformer = (userType: string, id: string, params) =>
    this._get(`/performer/${userType}/${id}`, { params });
  cancel = (id: string) => this._post(`/${id}/cancel`);
}
